<template>
  <div class="fixed bottom-6 left-1/2 z-50 -translate-x-1/2 transform">
    <div
      v-tooltip="{ value: t('contact.actions.impersonateStop'), showDelay: 300 }"
      class="is-primary is-large has-background-primary is-size-2 size-dvw cursor-pointer rounded-full p-2 p-4 text-white hover:text-orange-500"
      @click="stopImpersonation"
    >
      <FontAwesomeIcon
        class="transform transition-transform duration-200 hover:animate-pulse"
        :icon="['fas', 'person-to-portal']"
        size="lg"
      />
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import useImpersonation from '@/app/util/impersonation';

const { t } = useI18n();
const { stopImpersonation } = useImpersonation();

defineProps({
  profile: { type: Object, required: true },
});
</script>
